import React, { memo } from "react";
import { Box } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import TableRow from "../../common/TableRow";

import { useAppSelector } from "../../../../store/hooks";
import { selectAlerts } from "../../../../features/productAnalyzer/productAnalyzer.selector";
import { colorSets } from "../../const";
import {
  renderAmazonColor,
  renderPrivateLabelColor,
  renderIPAnalysisColor,
  renderSizeColor,
} from "./utils";

import { useStyles, ValueBox } from "./index.styles";
// import { selectIsFreePlan } from "../../../../features/pricingPlans/pricingPlans.selector";
import useProductAnalyzerParams from "../../../../hooks/useProductAnalyzerParams";

const Alerts: React.FC = () => {
  const classes = useStyles();
  const { alerts } = useAppSelector(selectAlerts);
  // const isFreePlan = useAppSelector(selectIsFreePlan);

  const { asin, lookupId } = useProductAnalyzerParams();

  if (!alerts) return null;

  const renderVariationsColor = (variations: number) =>
    variations === 0 ? colorSets.success : colorSets.warning;
  const renderHazmatColor = (hazmat: boolean) =>
    hazmat ? colorSets.danger : colorSets.success;

  return (
    <Box className={classes.root}>
      <TableRow
        label={"Amazon Share Buy Box"}
        value={
          <ValueBox color={renderAmazonColor(alerts)}>
            {alerts.amazonShareBuyBox?.includes("Not Likely") && (
              <>
                <ErrorOutlineIcon sx={{ fontSize: 16 }} />
                &nbsp;
              </>
            )}
            {alerts.amazonShareBuyBox ?? "-"}
          </ValueBox>
        }
      />
      <TableRow
        label={"Private Label"}
        value={
          <ValueBox color={renderPrivateLabelColor(alerts)}>
            {alerts.privateLabel?.includes("Maybe") && (
              <>
                <ErrorOutlineIcon sx={{ fontSize: 16 }} />
                &nbsp;
              </>
            )}
            {alerts.privateLabel ?? "-"}
          </ValueBox>
        }
      />
      <TableRow
        label={"IP Analysis"}
        value={
          <ValueBox color={renderIPAnalysisColor(alerts)} display="inline">
            {alerts.ipAnalysis?.includes("is known to have IP issues") && (
              <>
                <WarningIcon sx={{ fontSize: 16, color: "#A94442" }} />
                &nbsp;
              </>
            )}
            {alerts.ipAnalysis ?? "-"}
          </ValueBox>
        }
        // lock={isFreePlan}
        asin={asin}
        lookupId={lookupId}
      />
      <TableRow
        label={"Size"}
        value={
          <ValueBox sx={{ color: renderSizeColor(alerts) }}>
            {alerts.size ? alerts.size : "-"}
          </ValueBox>
        }
      />
      {alerts.fulfillmentFee === 0 && (
        <TableRow
          label={"Fulfillment Fee"}
          value={
            <ValueBox sx={{ color: colorSets.danger }}>
              <WarningIcon sx={{ fontSize: 16, color: "#A94442" }} />
              &nbsp;FBA Fee Unknown
            </ValueBox>
          }
        />
      )}
      <TableRow
        label={"Hazmat"}
        value={
          <ValueBox sx={{ color: renderHazmatColor(alerts.hazmat) }}>
            {alerts.hazmat ? "Yes" : "No"}
          </ValueBox>
        }
      />
      <TableRow
        label={"Meltable"}
        value={
          <ValueBox sx={{ color: renderHazmatColor(alerts.meltable) }}>
            {alerts.meltable ? "Yes" : "No"}
          </ValueBox>
        }
      />
      <TableRow
        label={"Variations"}
        value={
          <ValueBox sx={{ color: renderVariationsColor(alerts.variations) }}>
            {alerts.variations ? (
              <>
                <ErrorOutlineIcon sx={{ fontSize: 16 }} />
                &nbsp;
                {alerts.variations}&nbsp;variations
              </>
            ) : (
              "No"
            )}
          </ValueBox>
        }
      />
    </Box>
  );
};

export default memo(Alerts);
